export default "__VITE_ASSET__CyWZ5AZI__"